import LemonError from '@src/service/common/LemonError';

export default class LocaleNotInitializedException extends LemonError {
  constructor() {
    super(`'Localization library not initialize!`);
  }
}
